import React from "react";

const Decoration2 = () => {
  return (
    <div className="py-3">
      <img
        src="https://templates.microweber.com/wedding/userfiles/templates/wedding/assets/img/decoration-2.svg"
        alt="decoration-2"
        className="max-h-[40px] max-w-[500px] m-auto w-3/4 md:w-full"
      />
    </div>
  );
};

export default Decoration2;
